import React from "react";
import { useLocation, Link } from "react-router-dom";

import { useSelector } from "react-redux";

import { Menu, Tag } from "antd";

import navigation from "../../../../navigation/vertical";

export default function MenuItem(props) {
  const { onClose, handleLinkClick } = props;

  const customise = useSelector((state) => state.customise);

  // Location
  const location = useLocation();
  const { pathname } = location;

  const splitLocation = pathname.split("/");

  const menuItem = navigation
    .filter(({ hide }) => !hide)
    .map((item) => {
      const itemNavLink = item.navLink ? item.navLink.split("/") : "";

      return (
        // Level 1
        <Menu.Item
          key={item.id}
          icon={item.icon}
          onClick={onClose}
          className={
            splitLocation[1] === itemNavLink[1] ||
            (splitLocation[1] === "" && itemNavLink[1] === "agents")
              ? "ant-menu-item-selected"
              : "ant-menu-item-selected-in-active"
          }
          style={item.tag && { pointerEvents: "none" }}
        >
          {item.tag ? (
            <a
              href="#"
              className="hp-d-flex hp-align-items-center hp-d-flex-between"
            >
              <span>{item.title}</span>
              <Tag
                className="hp-mr-0 hp-border-none hp-text-color-black-100 hp-bg-success-3 hp-border-radius-full hp-px-8"
                style={{ marginRight: -14 }}
              >
                {item.tag}
              </Tag>
            </a>
          ) : (
            <Link
              to={item.navLink}
              onClick={(e) => handleLinkClick(e, item.navLink)}
            >
              {item.title}
            </Link>
          )}
        </Menu.Item>
      );
    });

  return (
    <Menu
      mode="inline"
      defaultOpenKeys={[
        splitLocation.length === 5
          ? splitLocation[splitLocation.length - 3]
          : null,
        splitLocation[splitLocation.length - 2],
      ]}
      theme={customise.theme == "light" ? "light" : "dark"}
      className="hp-bg-black-0 hp-bg-dark-90"
    >
      {menuItem}
    </Menu>
  );
}
